import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicationService } from '@sparro/app/core/api/publication/publication.service';
import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { ALLOWED_HOSTS } from '@sparro/app/core/config/constants.config';
import { ConfirmationDialogComponent } from '@sparro/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { PreviewPaneComponent, PreviewPaneData } from '@sparro/app/shared/components/dialogs/preview-pane/preview-pane.component';
import { SnackbarService } from '@sparro/core/helpers/toastr/snackbar.service';
import { environment } from '@sparro/env/environment';


@Component({
  selector: 'uni-publication-card',
  templateUrl: './publication-card.component.html',
  styleUrls: ['./publication-card.component.scss']
})
export class PublicationCardComponent implements OnInit {
  @Input() publication: any;
  @Input() host: ALLOWED_HOSTS;
  @Input() publicationType: string;
  @Input() footerType: string;
  @Input() hasImageBadge: boolean = false;
  @Input() hasImageFooter: boolean = false;
  @Input() showTimestamp: boolean = false;
  @Input() self: boolean;
  @Input() featured: boolean;
  @Input() showHeader: boolean = true;
  @Input() showCardOptions: boolean = true;
  @Output() redirectType = new EventEmitter();
  @Output() removed = new EventEmitter();
  @Output() dialogType = new EventEmitter();
  user: any;
  isSmall: boolean = false;

  constructor(
    public router: Router,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public publicationService: PublicationService,
    public snackbarService: SnackbarService,
    private _apiConfig: UniApiConfig,
  ) { }

  ngOnInit() {
  }

  openContentPage(value) {
    if (value === 'edit') {
      this.redirectType.emit(
        {
          type: 'draft',
          uuid: this.publication.uuid,
          slug: this.publication.slug ? this.publication.slug : null
        }
      );
    }
    else {
      this.redirectType.emit(
        {
          type: this.publicationType,
          uuid: this.publication.uuid,
          slug: this.publication.slug ? this.publication.slug : null
        }
      );
    }
  }

  checkHost() {
    if (this.host === 'evaluation') {
      this.router.navigate(['publication', this.publication.id], { relativeTo: this.route });
    } else if (this.host === 'b2b') {
      this.openDialog();
    }
  }

  getPublicationUrl() {
    if (this.publication.status === 'draft') {
      return `${environment.publicationUrl}edit/${this.publication.uuid}`;
    } else {
      return `${environment.publicationUrl}${this.publication.slug}`;
    }
  }

  deletePublication(event) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: 'Are you sure you want to delete this publication?',
        okayButtonText: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.publicationService.deletePublication(this.publication.uuid).subscribe(
          (response: any) => {
            this.removed.emit(this.publication.uuid);
            this.snackbarService.success(`Publication: ${this.publication.title} has been deleted.`);
          }, (err) => {
            console.log(err);
            this.snackbarService.error(`Publication could not be deleted.`);
          }
        );
      }
    });
  }

  openDialog(event?: string): void {
    const previewData: PreviewPaneData = {
      slug: this.publication.slug,
      entityType: this._apiConfig.publicationUrl,
    };
    this.dialog.open(PreviewPaneComponent, {
      height: '90vh',
      width: '80vw',
      data: previewData
    });
  }

}
